export default function Content() {
  const curDate = new Date();

  const why = {
    id: "why",
    h2: "💥 Why Choose EliteUKCasino.com?",
    ul: [
      "🎯 Expert Reviews: We offer unbiased, comprehensive reviews of the best online casinos in the UK. We evaluate everything from game selection and software quality to payment methods and customer support.",
      "🕵️‍♂️ Up-to-Date Information: Stay informed with the latest casino news, including updates on promotions, bonuses, and new game releases.",
      "🎁 Exclusive Bonuses: Access exclusive bonuses and deals at top UK casinos that you won't find anywhere else. Maximize your chances of winning with our carefully curated offers.",
      "📝 Tailored Recommendations: Whether you're into slots, table games, or live casinos, we provide personalized recommendations based on your preferences.",
      "⚠️ 18+ Only - You must be 18 years or older to participate. Please gamble responsibly and read our responsible gaming guidelines.",
    ],
  };

  const par2 = {
    id: "par-2",
    h2: "🎮 Explore Our Game Categories",
    ul: [
      "Slots: Discover the best slot games, from popular titles like Gates of Olympus to innovative new releases. Spin the reels at trusted UK casinos and enjoy the thrill of big wins.",
      "Table Games: Blackjack, Roulette, Poker - we've got all the classic table games covered. Find the best casinos to play your favorite games with great odds and exciting variants.",
      "Live Casino: Experience the excitement of live dealers in real time. Play Blackjack, Roulette, Baccarat, and more with professional dealers streaming from actual casinos.",
      "Bonuses & Promotions: Unlock the best welcome bonuses, free spins, reload bonuses, and more. Our curated list of promotions ensures you get the most value when signing up.",
    ],
  };

  const par3 = {
    id: "par-3",
    h2: "🚀 How We Help You Choose the Best UK Casinos",
    ul: [
      "Game Selection: We ensure the casino offers a wide variety of high-quality games from top software providers.",
      "Security: Only list casinos that are licensed and regulated by trusted authorities, ensuring a safe and secure environment for players.",
      "Payment Methods: Find casinos with fast, secure payment options, including credit cards, e-wallets, and more.",
      "Customer Support: We review the quality of customer service, ensuring you can get help whenever you need it.",
    ],
    p: "Our team of experts carefully reviews and ranks casinos based on the following criteria:",
  };

  return (
    <div className="content-container w-100 m-auto px-5 sm-p-1">
      <h1 className="fw-bold text-white">
        Welcome to EliteUKCasino.com - Your Ultimate UK Casino Comparison Site{" "}
        {curDate.getFullYear()}!
      </h1>
      <p>
        Looking for the best online casinos in the UK? You've come to the right
        place! At EliteUKCasino.com, we provide expert reviews, in-depth
        comparisons, and exclusive deals to help you find the top UK casinos
        that suit your needs. Whether you're a seasoned player or a newbie,
        we've got everything you need to enhance your gaming experience.
      </p>

      <div id={why.id}>
        <h2>{why.h2}</h2>
        <p>{why.p}</p>
        <ul className="list-unstyled">
          {why.ul.map((li, i) => (
            <li key={i}>
              <p>{li}</p>
            </li>
          ))}
        </ul>
      </div>

      <div id={par2.id}>
        <h2>{par2.h2}</h2>
        <ul>
          {par2.ul.map((li, i) => {
            const [title, text] = li.split(":");

            return (
              <li key={i}>
                <span className="fw-bold">{title}:</span> {text}
              </li>
            );
          })}
        </ul>
      </div>

      <div className="mt-3" id={par3.id}>
        <h2>{par3.h2}</h2>
        <p>{par3.p}</p>
        <ul>
          {par3.ul.map((li, i) => {
            const [title, text] = li.split(":");

            return (
              <li key={i}>
                <span className="fw-bold">{title}:</span> {text}
              </li>
            );
          })}
        </ul>
      </div>

      <div className="mt-4">
        <h2>🔎 Ready to Start Playing? </h2>
        <p>
          Explore our top casino recommendations and start your gaming journey
          today! With our expert guidance and exclusive offers, you'll find the
          best UK casinos for your playstyle and preferences. Play responsibly
          and enjoy the thrill of online gaming!
        </p>
      </div>

      <div>
        <h2>Play Responsibly!</h2>
        <p>
          Gambling can be addictive. Please gamble responsibly. For help, visit{" "}
          <a
            href="https://www.gambleaware.org/"
            rel="noreferrer"
            target="_blank"
          >
            BeGambleAware.org
          </a>
        </p>
      </div>
    </div>
  );
}
